// extracted by mini-css-extract-plugin
module.exports = {"orderAttributes":"OrderAttributesInfo_orderAttributes__yG4jZ","orderAttributesText":"OrderAttributesInfo_orderAttributesText__E9ePI"};